import styled from "@emotion/styled";
import { IconContainer as SocialButtonIconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  Container as SignUpNewsletterContainer,
  Title as SignUpNewsletterTitle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "large",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "portrait",
  root: {
    containerSize: "medium",
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    summaryFontStyle: "medium",
    titleFontStyle: "medium",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: true,
    hasSeeMoreLinks: true,
    titleFontStyle: "medium",
  },
};

export const Container = styled.div`
  ${SocialButtonIconContainer} {
    background-color: #ffffff;
  }
  ${SignUpNewsletterContainer} {
    ${SignUpNewsletterTitle} {
      color: #001246;
    }
  }
`;
